import { render, staticRenderFns } from "./linkpayment.vue?vue&type=template&id=332923c3"
import script from "./linkpayment.vue?vue&type=script&lang=js"
export * from "./linkpayment.vue?vue&type=script&lang=js"
import style0 from "./linkpayment.vue?vue&type=style&index=0&id=332923c3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports